"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { onAmountDrop } from "./amount_drop";
import Account from "../../api/account";
import Address from "./address";
import CarrierName from "../carrier_name";
import CarrierTypeAhead from "../carrier_typeahead";
import generalFormatter from "../../formatters/general";
import LineItems from "../carrier_invoice/line_items";
import PaymentStrategyEditor from "./payment_strategy_editor";
import PossibleAdjustments from "./possible_adjustments";
function onPaymentAmountDragOver(e) {
  e.preventDefault();
}
function shouldShowLineItems(props) {
  return Account.shouldShowLineItems() || props.creatingLoad;
}
function lineItems(props) {
  if (shouldShowLineItems(props)) {
    return /* @__PURE__ */ jsx("div", { className: "small-10 column", children: /* @__PURE__ */ jsx(
      LineItems,
      {
        carrierInvoice: props.carrierInvoice,
        payment: props.payment,
        load: props.load,
        creatingLoad: props.creatingLoad,
        invoiceChangeComplete: props.invoiceChangeComplete
      }
    ) });
  }
}
function remitToValidationMessage(props) {
  if (!Account.currentSettings().show_carrier_invoice_remit_to_validation) {
    return "";
  }
  switch (props.carrierInvoice.remit_to_validation_result) {
    case "no_tms_address":
      var message = "No pay-to address found in TMS.";
      var className = "warning";
      break;
    case "remit_to_zips_match":
      var message = "Pay-to zip codes match.";
      var className = "success";
      break;
    case "check_factor_remit_to":
      var message = "Pay-to may not match factored invoice.";
      var className = "error";
      break;
    case "check_remit_to":
      var message = "Pay-to may not match invoice.";
      var className = "error";
      break;
    case "cant_find_remit_to_zip":
      var message = "Can't find pay-to zip code.";
      var className = "error";
      break;
    case "triumphpay_remit_to":
      var message = "Pay via TriumphPay";
      var className = "success";
      break;
    case "triumphpay_inconclusive":
      var message = "Pay via TriumphPay";
      var className = "";
      break;
    default:
      return "";
  }
  className += " load-detail__remit_to_validation";
  return /* @__PURE__ */ jsx("div", { className, children: message });
}
function remitToUpdateReminder(props) {
  if (Account.currentSettings().use_triumph_pay_carrier_remit_to && props.carrierInvoice.remit_to_validation_result != "remit_to_zips_match") {
    return /* @__PURE__ */ jsx("div", { className: "load-detail__remit_to_update_reminder", children: "If needed, send NOA to TriumphPay or update remittance in your system. Updates may not appear immediately." });
  }
}
function possiblePossibleAdjustments(props) {
  if (props.carrierInvoice.quickpay_disposition === "not_applied_to_invoice") {
    return /* @__PURE__ */ jsx(
      PossibleAdjustments,
      {
        expectedTotal: tmsTotal(props),
        load: props.load,
        carrierInvoice: props.carrierInvoice
      }
    );
  }
}
function tmsTotal(props) {
  if (props.load.load.carrier_charge) {
    return parseFloat(props.load.load.carrier_charge);
  }
  return 0;
}
function payToLabel(props, state) {
  if (Account.currentSettings().use_triumph_pay_carrier_remit_to && props.carrier.payment_address_source === "triumphpay") {
    return "TriumphPay Payee";
  }
  if (state.editing) {
    return Account.carrierTerm() + " Payment Settings";
  }
  if (!allowEditingCarrierPaymentStrategy(props)) {
    return Account.carrierTerm() + " Remittance Address";
  }
  switch (props.carrier.payment_strategy) {
    case "direct":
      return "Pay Direct to " + Account.carrierTerm();
    case "factor":
      return "Pay Via Factor";
    default:
      return "Pay To";
  }
}
function carrierForTypeahead(props, state) {
  return state.carrier || props.carrier;
}
function cancelEditingCarrier(props) {
  var _a;
  (_a = props.onCarrierChanged) == null ? void 0 : _a.call(props, null);
}
function updateField(props, field) {
  return (event) => {
    var _a;
    (_a = props.updatePaymentField) == null ? void 0 : _a.call(props, field, event.target.value);
  };
}
function allowEditingCarrierPaymentStrategy(props) {
  return Account.currentSettings().allow_editing_carrier_payment_strategy && props.carrier.payment_strategy != "triumphpay";
}
class PaymentInformation extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {});
    __publicField(this, "input", (field, type) => {
      if (field == "payOn") {
        return /* @__PURE__ */ jsx(
          "input",
          {
            type,
            value: this.props.payment[field],
            onChange: updateField(this.props, field),
            disabled: this.props.readOnly
          }
        );
      } else {
        const { value, requestChange } = this.myLinkState(field);
        return /* @__PURE__ */ jsx(
          "input",
          {
            type,
            disabled: this.props.readOnly,
            value,
            onChange: (e) => requestChange(e.target.value),
            onBlur: this.props.invoiceChangeComplete,
            onKeyDown: this.props.keyPressNotifier(field),
            onDragOver: onPaymentAmountDragOver,
            onDrop: onAmountDrop,
            placeholder: "Payment Amount"
          }
        );
      }
    });
    __publicField(this, "myLinkState", (field) => {
      var component = this;
      var value = this.state[field] || this.props.payment["amount"];
      return {
        value,
        requestChange: function(value2) {
          var _a;
          var state = {};
          state[field] = value2;
          component.setState(state);
          var vl = (_a = generalFormatter.cleanAmount(value2)) != null ? _a : "";
          component.props.updatePaymentField(field, vl);
          component.props.invoiceFieldChanged(field, vl);
        }
      };
    });
    __publicField(this, "paymentDueOnInput", () => {
      if (Account.carrierInvoiceCanModifyPaymentDueOn()) {
        return /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("label", { children: "Payment Due On" }),
          this.input("payOn", "date")
        ] });
      } else {
        return /* @__PURE__ */ jsx("div", {});
      }
    });
    __publicField(this, "invoiceCarrierOrEditor", () => {
      if (this.state.editingCarrier) {
        return /* @__PURE__ */ jsx("div", { className: "load-detail__invoice-name-editor", children: /* @__PURE__ */ jsx(
          CarrierTypeAhead,
          {
            carrier: carrierForTypeahead(this.props, this.state),
            onSelectCarrier: this.carrierWasSet,
            onClearCarrier: () => cancelEditingCarrier(this.props)
          }
        ) });
      }
      return /* @__PURE__ */ jsxs("h6", { children: [
        /* @__PURE__ */ jsx(CarrierName, { carrierID: this.props.carrier.id }),
        "\xA0",
        this.possibleCarrierEditorLink()
      ] });
    });
    __publicField(this, "possibleCarrierEditorLink", () => {
      if (!this.props.readOnly) {
        return /* @__PURE__ */ jsx("a", { onClick: this.startEditingCarrier, children: /* @__PURE__ */ jsx("i", { className: "fi-pencil" }) });
      }
    });
    __publicField(this, "carrierWasSet", (carrier) => {
      this.setState({ carrier });
      this.props.onCarrierChanged(carrier);
    });
    __publicField(this, "startEditingCarrier", () => {
      this.setState({ editingCarrier: true });
    });
    __publicField(this, "addressOrEditor", () => {
      if (this.state.editing) {
        return /* @__PURE__ */ jsx(
          PaymentStrategyEditor,
          {
            carrier: this.props.carrier,
            onSave: this.savePaymentStrategy
          }
        );
      }
      return /* @__PURE__ */ jsx(Address, { source: this.props.carrier.payment_address });
    });
    __publicField(this, "saveAddress", (address) => {
      return this.props.saveAddress(address).then(() => {
        this.setState({ editing: false });
      });
    });
    __publicField(this, "savePaymentStrategy", (paymentStrategy, details) => {
      return this.props.savePaymentStrategy(paymentStrategy, details).then(
        () => this.setState({ editing: false })
      );
    });
    __publicField(this, "possibleEditAddressLink", () => {
      if (this.props.canEditAddress && !this.props.readOnly && allowEditingCarrierPaymentStrategy(this.props)) {
        if (this.state.editing) {
          return /* @__PURE__ */ jsx("a", { className: "right payment-info__edit", onClick: this.cancelEditing, children: "cancel" });
        }
        return /* @__PURE__ */ jsx("a", { className: "right payment-info__edit", onClick: this.startEditing, children: "edit" });
      }
    });
    __publicField(this, "startEditing", () => {
      this.setState({ editing: true });
    });
    __publicField(this, "cancelEditing", () => {
      this.setState({ editing: false });
    });
  }
  render() {
    return /* @__PURE__ */ jsx("div", { "data-component": "PaymentInformation", children: /* @__PURE__ */ jsxs("div", { className: "row load-detail__invoice-area", children: [
      /* @__PURE__ */ jsxs("div", { className: "small-5 column", children: [
        /* @__PURE__ */ jsx("label", { children: "Payment Amount" }),
        /* @__PURE__ */ jsxs("div", { className: "row collapse", children: [
          /* @__PURE__ */ jsx("div", { className: "small-1 columns", children: /* @__PURE__ */ jsx("span", { className: "prefix", children: "$" }) }),
          /* @__PURE__ */ jsxs("div", { className: "small-9 columns", children: [
            this.input("amount_to_pay", "text"),
            possiblePossibleAdjustments(this.props)
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "small-5 column", children: this.paymentDueOnInput() }),
      lineItems(this.props),
      /* @__PURE__ */ jsxs("div", { className: "load-detail__invoice-carrier-container", children: [
        /* @__PURE__ */ jsx("div", { className: "small-5 column", children: /* @__PURE__ */ jsxs(
          "div",
          {
            className: "load-detail__name-wrapper",
            style: { display: "flex", justifyContent: "space-between" },
            children: [
              /* @__PURE__ */ jsxs("div", { className: "load-detail__name-container", children: [
                /* @__PURE__ */ jsxs(
                  "label",
                  {
                    className: "load-detail__invoice-label",
                    "data-tooltip": true,
                    "aria-haspopup": "true",
                    title: "The " + Account.carrierTerm() + " who the payment will be sent to",
                    children: [
                      "Invoice ",
                      Account.carrierTerm()
                    ]
                  }
                ),
                /* @__PURE__ */ jsxs("label", { className: "load-detail__invoice-name-label show_for_reskin", children: [
                  Account.carrierTerm(),
                  " name"
                ] }),
                this.invoiceCarrierOrEditor()
              ] }),
              this.props.children
            ]
          }
        ) }),
        /* @__PURE__ */ jsxs("div", { className: "small-5 column load-detail__invoice_address_container", children: [
          /* @__PURE__ */ jsxs("label", { children: [
            payToLabel(this.props, this.state),
            this.possibleEditAddressLink()
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "load-detail__invoice_address", children: [
            this.addressOrEditor(),
            remitToValidationMessage(this.props),
            remitToUpdateReminder(this.props)
          ] })
        ] })
      ] })
    ] }) });
  }
}
export default PaymentInformation;
